import { traverseAst } from "./traverse-ast.js";
const matchRule = (ast, rule) => {
  return (!rule.types || rule.types.includes(ast.type)) && (!rule.keys || rule.keys.includes(ast.key)) && (!rule.ops || rule.ops.includes(ast.op)) && (!rule.matchValue || rule.matchValue(ast.value.value));
};
const transformVisitor = (rules, context) => (ast) => {
  return rules.reduce((ast2, rule) => {
    if (!matchRule(ast2, rule)) {
      return ast2;
    }
    return rule.transform(ast2, context) || ast2;
  }, ast);
};
const transformAst = (ast, context, rules, optimizeRules = []) => {
  return traverseAst(ast, {
    before: transformVisitor(rules, context),
    after: transformVisitor(optimizeRules, context)
  });
};
export {
  transformAst
};
//# sourceMappingURL=transform-ast.js.map
